import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  image: string;
  content: string;
  rating: number;
}
const TestimonialCard = ({
  name,
  role,
  image,
  content,
  rating
}: TestimonialCardProps) => {
  return <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-262">
      <div className="flex items-center mb-4" data-id="element-263">
        <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-264" />
        <div data-id="element-265">
          <h4 className="font-semibold" data-id="element-266">{name}</h4>
          <p className="text-sm text-gray-600" data-id="element-267">{role}</p>
        </div>
      </div>
      <div className="flex mb-3" data-id="element-268">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-269" />)}
      </div>
      <p className="text-gray-700 italic" data-id="element-270">"{content}"</p>
    </div>;
};
export default TestimonialCard;